import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum CandidatureAddByOrderIdErrorType {
  DRIVER_HAS_CANDIDATURE = "DRIVER_HAS_CANDIDATURE",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  TAXI_DRIVER_ASSOCIATION_NOT_EXISTS = "TAXI_DRIVER_ASSOCIATION_NOT_EXISTS",
  TAXI_DRIVER_CONTRACT_NOT_VALID = "TAXI_DRIVER_CONTRACT_NOT_VALID",
  TAXI_RAILY_CONTRACT_NOT_VALID = "TAXI_RAILY_CONTRACT_NOT_VALID",
  ORDER_NOT_EXISTS = "ORDER_NOT_EXISTS",
  ORDER_IN_PROGRESS = "ORDER_IN_PROGRESS",
  PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR = "PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR",
  SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR = "SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
}

export enum CandidatureAddByOrderIdCollisionSubjectDirection {
  PREVIOUS = "PREVIOUS",
  NEXT = "NEXT",
}

export type CandidatureAddByOrderIdDriverHasCandidatureError = DataLoadError<
  CandidatureAddByOrderIdErrorType.DRIVER_HAS_CANDIDATURE,
  {}
>;

export type CandidatureAddByOrderIdEntryCandidateCollisionError = DataLoadError<
  CandidatureAddByOrderIdErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
  {}
>;

export type CandidatureAddByOrderIdTaxiDriverAssociationNotExistsError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    {}
  >;

export type CandidatureAddByOrderIdTaxiDriverContractNotValidError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    {}
  >;

export type CandidatureAddByOrderIdTaxiRailyContractNotExistsError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    {}
  >;

export type CandidatureAddByOrderIdOrderNotExistsError = DataLoadError<
  CandidatureAddByOrderIdErrorType.ORDER_NOT_EXISTS,
  {}
>;

export type CandidatureAddByOrderIdOrderInProgressError = DataLoadError<
  CandidatureAddByOrderIdErrorType.ORDER_IN_PROGRESS,
  {}
>;

export type CandidatureAddByOrderIdPlanEntryCandidateStartTimeExpiredError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR,
    {}
  >;

export type CandidatureAddByOrderIdSolvedOrderCandidateStartTimeExpiredError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR,
    {}
  >;

export type CandidatureAddByOrderIdCandidateFitsWithNotEnoughTimeError =
  DataLoadError<
    CandidatureAddByOrderIdErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME,
    {
      requiredGap: number;
      existingGap: number;
      collisionDirection: CandidatureAddByOrderIdCollisionSubjectDirection;
    }
  >;

export type CandidatureAddByOrderIdCandidatureDoesNotFitError = DataLoadError<
  CandidatureAddByOrderIdErrorType.CANDIDATE_DOES_NOT_FIT,
  {
    requiredGap: number;
    existingGap: number;
    collisionDirection: CandidatureAddByOrderIdCollisionSubjectDirection;
  }
>;

type CandidatureAddByOrderIdError =
  | DataLoadDefaultErrors
  | CandidatureAddByOrderIdDriverHasCandidatureError
  | CandidatureAddByOrderIdEntryCandidateCollisionError
  | CandidatureAddByOrderIdTaxiDriverAssociationNotExistsError
  | CandidatureAddByOrderIdTaxiDriverContractNotValidError
  | CandidatureAddByOrderIdTaxiRailyContractNotExistsError
  | CandidatureAddByOrderIdOrderNotExistsError
  | CandidatureAddByOrderIdOrderInProgressError
  | CandidatureAddByOrderIdPlanEntryCandidateStartTimeExpiredError
  | CandidatureAddByOrderIdSolvedOrderCandidateStartTimeExpiredError
  | CandidatureAddByOrderIdCandidateFitsWithNotEnoughTimeError
  | CandidatureAddByOrderIdCandidatureDoesNotFitError;

export default CandidatureAddByOrderIdError;
